import { useActiveOrganization } from '../../contexts/auth';
import { CreateExtractionFormContainer } from '../../contexts/extractions';

export function ExtractionCreatePage() {
  const { organization } = useActiveOrganization();

  return (
    <div className="space-y-6">
      <header className="space-y-1.5">
        <h1 className="text-[22px] font-semibold leading-tight tracking-tight text-foreground">
          Create an extraction
        </h1>
        <p className="text-[13.5px] leading-relaxed text-muted-foreground max-w-2xl">
          Define the prompt and output schema for extracting structured data from conversations.
        </p>
      </header>
      {organization && <CreateExtractionFormContainer orgId={organization.id} />}
    </div>
  );
}
